import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const accentColors = {
    default: "var(--accent)",
    info: "var(--info-500)",
    warn: "var(--warn-500)",
    success: "var(--emerald-500)",
};
export function KpiCard({ label, value, hint, cta, accent = "default", icon }) {
    return (_jsxs("article", { style: {
            background: "var(--surface)",
            border: "1px solid var(--border)",
            borderRadius: 16,
            padding: 20,
            backdropFilter: "blur(8px)",
            display: "flex",
            flexDirection: "column",
            gap: 10,
            minHeight: 144,
        }, children: [_jsxs("div", { style: { display: "flex", alignItems: "center", gap: 10, color: accentColors[accent] }, children: [icon, _jsx("span", { style: { fontSize: 13, fontWeight: 600, color: "var(--text)" }, children: label })] }), _jsx("div", { style: { fontSize: "2.2rem", fontWeight: 800, letterSpacing: "-0.03em", color: accentColors[accent] }, children: value }), hint ? _jsx("div", { style: { fontSize: 12, color: "var(--text-muted)" }, children: hint }) : null, cta ? (_jsx("button", { type: "button", onClick: cta.onClick, style: {
                    alignSelf: "flex-start",
                    marginTop: "auto",
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: "0.06em",
                    textTransform: "uppercase",
                    color: "var(--accent)",
                    background: "transparent",
                    border: "1px solid var(--border-strong)",
                    borderRadius: 999,
                    padding: "6px 12px",
                    cursor: "pointer",
                }, children: cta.label })) : null] }));
}
//# sourceMappingURL=KpiCard.js.map